import  React, { lazy } from 'react';
import DashboardMain from '../pages/Dashboard/DashboardMain';
import OperationList from '../pages/Operation/OperationList';
import BusinessList from '../pages/Business/BusinessList';
import RateList from '../pages/Rate/RateList';
import BusinessWorkspace from '../pages/Business/BusinessWorkspace';
import UserList from '../pages/User/UserList';
import DashboardBusiessMain from '../pages/DashboardBusiness/DashboardBusiessMain';
import BankList from '../pages/Bank/BankList';
import BankNameVariantList from '../pages/BankNameVariant/BankNameVariantList';
import OperationBalanceList from '../pages/OperationBalance/OperationBalanceList';
import { BusinessFormWizard } from '../pages/Business/BusinessFormWizard';
import DashboardMarja from '../pages/DashboardBusiness/DashboardMarja';
import DashboardConversion from '../pages/DashboardBusiness/DashboardConversion';

import { BusinessFormWizardProvider } from '../pages/Business/BusinessFormWizardProvider';

import DashboardMarjaPlatform from '../pages/DashboardBusiness/DashboardMarjaPlatform';
import ContragentList from '../pages/Contragent/ContragentList';
import BalancesPage from '../pages/Balances/BalancesPage';
import { BASE_URL } from '../shared/consts/baseUrl';
//const Dashboard = lazy(() => import('../components/Dashboard/Dashboard'));

// const DemoPage = lazy(() => import('../pages/DemoPage/DemoPage'));

export const RouterData = [

               {path:`${BASE_URL}dashboard`, element:<DashboardBusiessMain idBusinessProps={null} />},

               {path:`${BASE_URL}dashboard/marja`, element:<DashboardMarja title="Маржа" />},

               {path:`${BASE_URL}dashboard/marja/platform`, element:<DashboardMarjaPlatform title="Маржа платформа/фиат" />},

               

               {path:`${BASE_URL}dashboard/convertion`, element:<DashboardConversion title="Конверсия" />},
               
               
               

               {path:`${BASE_URL}operation/list`, element:<OperationList key="all" listFilterFieldProps={[]} title='Все операции'/>},

               {path:`${BASE_URL}operation/payin/list`, element:<OperationList key="payIn" listFilterFieldProps={[{fieldName: "typeOperation", comparison: "equalsStrong", listVal: ["payIn"]}]} title='Pay In'/>},

               {path:`${BASE_URL}operation/payout/list`, element:<OperationList key="payOut" listFilterFieldProps={[{fieldName: "typeOperation", comparison: "equalsStrong", listVal: ["payOut"]}]} title='Pay Out'/>},


               
               {path:`${BASE_URL}merchant/list`, element:<BusinessList key="typeBusinessMerchant" listFilterFieldProps={[{fieldName: "typeBusiness", comparison: "equalsStrong", listVal: ["merchant"]}]}/>},
               {path:`${BASE_URL}provider/list`, element:<BusinessList key="typeBusinessProvider" listFilterFieldProps={[{fieldName: "typeBusiness", comparison: "equalsStrong", listVal: ["provider"]}]}/>},

               {path:`${BASE_URL}provider/list`, element:<BusinessList listFilterFieldProps={[]}/>},

               {path:`${BASE_URL}rate/list`, element:<RateList listFilterFieldProps={[]}/>},

               {path:`${BASE_URL}business/:slug`, element:<BusinessWorkspace/>},

               {path:`${BASE_URL}business/wizard`, element:<BusinessFormWizard/>},

               {path:`${BASE_URL}business/wizard/provider`, element:<BusinessFormWizardProvider/>},

               
               {path:`${BASE_URL}user/list`, element:<UserList listFilterFieldProps={[]}/>},


               {path:`${BASE_URL}bank/list`, element:<BankList listFilterFieldProps={[]}/>},

               {path:`${BASE_URL}banknamevariant/list`, element:<BankNameVariantList listFilterFieldProps={[]}/>},

               {path:`${BASE_URL}operationbalance/list`, element:<OperationBalanceList listFilterFieldProps={[]} title="Операции баланса"/>},

               {path:`${BASE_URL}balances`, element:<BalancesPage />},

               {path:`${BASE_URL}contragent/list`, element:<ContragentList />},


                  
               
               
               

            //    {path:`${BASE_URL}demo`, element:<DemoPage />},

            

            
]
